export default {
  // OneTimeTask.vue translations
  addMember: "اضافة عضو",
  email: "البريد الالكتروني",
  emailExistsError:
    "هذا البريد الالكتروني مسجل بالفعل. يرجى استخدام بريد الكتروني اخر.",
  generalError: "حدث خطأ في التقديم. يرجى المحاولة مرة اخرى في وقت لاحق.",
  invalidCompanyIdOrUserId: "معرف الشركة أو معرف المستخدم غير صحيح.",
  oneTimeTaskDeleted: "تم حذف المهمة الواحدة بنجاح.",
  oneTimeTaskAdded: "تم إضافة المهمة الواحدة بنجاح.",
  deleteConfirmationTitle: "حذف المهمة الواحدة",
  deleteConfirmationText: "هل تريد حذف هذه المهمة الواحدة؟",
  delete: "حذف",
  addRoutineTask: "إضافة مهمة واحدة",
  taskName: "*اسم المهمة",
  description: "وصف المهمة",
  assignTo: "*تعيين",
  selectSupervisor: "اختر المشرف",
  supervisor: "المشرف",
  informer: "المعلوم",
  consultant: "الاستشارات",
  close: "اغلاق",
  create: "اضافة",
  editOneTimeTask: "تعديل المهمة الواحدة",
  update: "تحديث",
  oneTimeTasks: "المهام الواحدة",
  TaskNameRequired: "يرجى ادخال اسم المهمة.",
  TaskAddedError: "حدث خطأ في إضافة المهمة. يرجى المحاولة لاحقاً.",
  from: "من",
  to: "إلى",
  TaskManager: "مدير المهمة",
  assignManager: "تعيين المدير",
  enterDescription: "ادخال الوصف",
  enterTaskName: "ادخل اسم المهمة",
  createOneTimeTask: "إنشاء مهمة واحدة",
  saving: "يتم الحفظ...",
  noRoutineTasks: "لا توجد مهام واحدة.",
  createee: "أنشئ مهامك الواحدة",
  inactive: "غير نشط",
  active: "نشط",
  advancedSettings: "الإعدادات المتقدمة",
  taskNumber: "رقم المهمة",
  taskType: "نوع المهمة",
  selectTaskType: "اختر نوع المهمة",
  recurrentDays: "أيام التكرار",
  enterRecurrentDays: "ادخل عدد أيام التكرار",
  dayOfMonth: "يوم الشهر",
  enterDayOfMonth: "ادخل يوم الشهر مثل 1, 2,... 31",
  department: "القسم",
  selectDepartment: "اختر القسم",
  sunday: "الاحد",
  monday: "الاثنين",
  tuesday: "الثلاثاء",
  wednesday: "الاربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  enterStartDate: "ادخل تاريخ البدء",
  startDate: "تاريخ البدء",
  endDate: "تاريخ الانتهاء",
  allProjects: "جميع المشاريع",
  weekly: "اسبوعي",
  monthly: "شهري",
  daily: "يومي",
  applyFilters: "تطبيق التصفيات",
  resetFilters: "اعادة تعيين التصفيات",
  selectAll: "اختر الكل",
  departmentsSelected: "اقسام محددة",
  done: "تم",
  not_done: "لم يتم",
  inProgress: "قيد التنفيذ",
  pending: "قيد الانتظار",
  review: "قيد المراجعة",
  allPriorities: "جميع الأولويات",
  allEmployees: "جميع الموظفين",
  allDeadLines: "جميع المواعيد",
  high: "عالية",
  normal: "عادية",
  low: "منخفضة",
  urgent: "عاجلة",
  overDue: "متأخر",
  soon: "قريب خلال 2 يوم",
  noDueDate: "غير محدد",
  hasNewUpdate: "يوجد تحديث جديد",
  not_reported: "لم يتم التقرير",
  LatedTasks: "مهام متاخرة",
  project: "المشروع",
  isUrgent: "هامة جدا",
  priority: "الاولوية",
  employee: "الموظف",
  selectProject: "اختر المشروع",
  searchPlaceholder: "ابحث عن طريق اسم المهمة, الموظف ...",
  selectEmployee: "اختر الموظفين",
  selectConsultant: "اختر الاسشاري",
  selectInformer: "اختر المعلوم",
  selectDeadline: "اختر الموعد",
  deadLine: "الموعد",
  selectTask: "اختر المهمة",
  selectPriority: "اختر الأولوية",
  undo: "تراجع",
  redo: "إعادة",
  bold: "عريض",
  italic: "مائل",
  underline: "تسطير",
  alignLeft: "محاذاة لليسار",
  alignCenter: "محاذاة للمنتصف",
  alignRight: "محاذاة لليمين",
  bulletList: "قائمة نقطية",
  numberedList: "قائمة مرقمة",
  link: "إدراج رابط",
  image: "إدراج صورة",
  moreOptions: "خيارات إضافية",
  selectStartDate: "اختر تاريخ البدء",
  selectEndDate: "اختر تاريخ الانتهاء",
  noResultsFound: "لا توجد نتائج",
  clickToAddPeople: "انقر لإضافة أشخاص",
  // Missing keys from usage
  errorOccurred: "حدث خطأ",
  projectsSelected: "مشاريع محددة",
  clickToEdit: "انقر للتعديل",
  enterEndDate: "ادخل تاريخ الانتهاء",
  searchEmployee: "ابحث عن الموظف",
  // OneTimeTaskTable.vue translations
  tasksTable: "عدد المهام",
  noTasksHere: "لا توجد مهام هنا.",
  comment: "تعليق",
  reply: "رد",
  cancel: "إلغاء",
  submit: "إرسال",
  log: "السجلات",
  info: "معلومات",
  assignedTo: "إلى",
  createdBy: "أنشئت بواسطة",
  supervisorAccountable: "المسؤول", // Used in OneTimeTaskTable.vue as "Accountable"
  noLogsAvailable: "لا توجد سجلات",
  deleteConfirmationSuccess: "تم حذف المهمة بنجاح",
  reportTaskType: "تقرير نوع المهمة",
  selectReportTaskType: "اختر نوع التقرير",
  taskFound: "هل المهمة موجودة؟",
  selectTaskFound: "اختر المهمة موجودة",
  errorUpdatingTask: "خطأ في تحديث المهمة",
  errorUpdatingStatus: "خطأ في تحديث حالة المهمة",
  taskReportedSuccessfully: "تمت العملية بنجاح",
  editTask: "تعديل مهمة",
  comment_text: "التعليق",
  write_comment: "اكتب تعليقًا",
  writeComment: "اكتب تعليقك هنا...",
  submitting: "جاري الإرسال...",
  upload: "رفع الملف",
  uploading: "جاري رفع الملف...",
  changedTheField: "غير الحقل",
  onDate: "في تاريخ",
  noTasks: "لا توجد مهام",
  createdAt: "تاريخ الإنشاء",
  assignedUser: "المسؤول",
  fromTime: "من الوقت",
  dayOfWeek: "يوم الأسبوع",
  tasks: "مهام",
  taskReportedSuccessfullyMessage: "تم الإبلاغ عن المهمة بنجاح",
  yes: "نعم",
  no: "لا",
  deadline: "الموعد النهائي",
  rework: "إعادة العمل",
  taskStatusUpdated: "تم تحديث حالة المهمة",
  success: "نجاح",
  archive: "أرشيف",
  restore: "استرجاع",
  taskArchivedSuccessfully: "تم أرشفة المهمة بنجاح",
  taskRestoredSuccessfully: "تم استرجاع المهمة بنجاح",
  edit: "تعديل",
  uploadError: "خطأ في الرفع",
  fileSizeExceedsLimit: "حجم الملف يتجاوز الحد المسموح به وهو {size}.",
  maxFileSize: "الحجم الأقصى للملف: {size}",
  consult: "مُستشار",
  // Tab names
  inbox: "صندوق الوارد",
  own: "خاص بي",
  started: "بدأت",
};
